export default __webpack_public_path__ + "static/media/adding-contacts.3789575f.png";